module.exports = __webpack_public_path__ + "static/media/0026_IMG_LES_MURS_SLOE_W_VSL2100_HORIZONTALE.cd096f3e.png";